/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import API from "../../../utils/API";
import MUIDataTable from "mui-datatables";
import { SaleUtils } from "../../../utils/SaleUtils";
import { StringUtils } from "../../../utils/StringUtils";

export default function ProductStockBatchView(props) {
  const { t } = useTranslation();
  const translate = t;
  const [stockBatchList, setStockBatchList] = useState([]);
  const [costLIFO, setCostLIFO] = useState("0.000");
  const [costFIFO, setCostFIFO] = useState("0.000");
  const [costAVERAGE, setCostAVERAGE] = useState("0.000");

  useEffect(() => {
    if (props.origObject && props.origObject.stockBean) {
      fetchStockBatch(props.origObject.stockBean.id);
    }
  }, []);

  async function fetchStockBatch(stockId) {
    {
      try {
        let { data } = await API.get("/api/v1/stock/batch/" + stockId);
        setStockBatchList(data);
        let LIFO = await SaleUtils.getProductCostFromBatch(data, "LIFO", 0.0);
        let FIFO = await SaleUtils.getProductCostFromBatch(data, "FIFO", 0.0);
        let averageCost = await SaleUtils.getProductCostFromBatch(
          data,
          "AVERAGE",
          0.0
        );
        setCostLIFO(LIFO.toFixed(3));
        setCostFIFO(FIFO.toFixed(3));
        setCostAVERAGE(averageCost.toFixed(3));
      } catch (err) {
        if (err.response && err.response.status == 404) {
          props.showMessage("warning", translate("No batches found!"));
        } else {
          props.showMessage(
            "error",
            translate("Not able to retrive batch info from server")
          );
        }
      }
    }
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 550,
  };

  function formatDate(date) {
    let formatted =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

    return formatted;
  }

  const columns = [
    {
      name: "batchNumber",
      label: translate("Batch Number"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: "45px" }}>{translate("Batch Number")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div style={{ paddingLeft: "48px" }}>{value}</div>;
        },
      },
    },
    {
      name: "batchDate",
      label: translate("Batch Date"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "initialQty",
      label: translate("Initial Qty"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "remainingQty",
      label: translate("Remaining Qty"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "receivedCost",
      label: translate("Received Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div style={{ paddingLeft: "55px" }}>{value.toFixed(3)}</div>;
        },
      },
    },
    {
      name: "currentCost",
      label: translate("Current Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div style={{ paddingLeft: "48px" }}>{value.toFixed(3)}</div>;
        },
      },
    },
  ];

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <MUIDataTable
            data={stockBatchList}
            columns={columns}
            options={options}
          />
        </Grid>
        <Grid item xs={5} sx={{ pl: "10px" }}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="20%">FIFO</td>
                <td>
                  <b>{costFIFO}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={5}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="30%">AVERAGE</td>
                <td>
                  <b>{costAVERAGE}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={2}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="45%">LIFO</td>
                <td>
                  <b>{costLIFO}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );
}
